export const LMS_CARRIERS = ['AC', 'AF', 'AI', 'G3', 'KL', 'MH', 'NZ', 'SK', 'UW', 'VS']
export const NON_LMS_CARRIERS = ['AA', 'UA', 'AF-KL']

export const getAirlineCodeByCarrier = (carrier: string) => {
    switch (carrier.toUpperCase()) {
        case 'AA':
            return '001'
        case 'AC':
            return '014'
        case 'AF-KL':
        case 'AF':
            return '057'
        case 'KL':
            return '074'
        case 'AI':
            return '098'
        case 'MH':
            return '232'
        case 'NZ':
            return '086'
        case 'SK':
            return '117'
        case 'UA':
            return '016'
        case 'UW':
            return '777'
        default:
            return '000'
    }
}

export const AC_CARRIER = 'AC'
export const AI_CARRIER = 'AI'
export const AZ_CARRIER = 'AZ'
export const QR_CARRIER = 'QR'
export const AY_CARRIER = 'AY'
export const AA_CARRIER = 'AA'
